(function () {
  var SECTION_TYPE = 'testimonials-living-oceans';

  function getVisibleCount(row) {
    var raw = getComputedStyle(row).getPropertyValue('--tlo-visible-count');
    var n = parseInt(raw, 10);
    if (isNaN(n) || n < 1) n = 1;
    return n;
  }

  function getStepSize(track) {
    var first = track.querySelector('.testimonials-lo__card');
    if (!first) return 0;
    var styles = getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function clampIndex(index, max, loop) {
    if (loop) {
      if (max <= 0) return 0;
      return ((index % max) + max) % max;
    }
    if (index < 0) return 0;
    if (index > max) return max;
    return index;
  }

  function init(container) {
    if (!container || container.dataset.bound === 'true') return;
    container.dataset.bound = 'true';

    var row = container.querySelector('[data-tlo-row]');
    var track = container.querySelector('[data-tlo-track]');
    var prev = container.querySelector('[data-tlo-prev]');
    var next = container.querySelector('[data-tlo-next]');
    var wave = container.querySelector('[data-tlo-wave]');

    var waveObserver = null;
    if (wave) {
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || !('IntersectionObserver' in window)) {
        wave.classList.add('is-revealed');
      } else {
        waveObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              wave.classList.add('is-revealed');
              waveObserver.disconnect();
              waveObserver = null;
            }
          });
        }, { threshold: 0.15 });
        waveObserver.observe(container);
      }
    }

    if (!row || !track) {
      container._tloCleanup = function () {
        if (waveObserver) waveObserver.disconnect();
      };
      return;
    }

    var cards = track.querySelectorAll('.testimonials-lo__card');
    var loop = container.dataset.loop === 'true';
    var index = 0;

    function maxIndex() {
      var visible = getVisibleCount(row);
      return Math.max(0, cards.length - visible);
    }

    function update() {
      var step = getStepSize(track);
      var offset = step * index;
      track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
      if (prev) prev.setAttribute('aria-disabled', (!loop && index <= 0) ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', (!loop && index >= maxIndex()) ? 'true' : 'false');
    }

    function go(delta) {
      var target = clampIndex(index + delta, maxIndex(), loop);
      if (target === index) return;
      index = target;
      update();
    }

    function onPrev(e) { e.preventDefault(); go(-1); }
    function onNext(e) { e.preventDefault(); go(1); }
    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);

    function onKey(e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    }
    row.addEventListener('keydown', onKey);

    var dragStartX = 0;
    var dragDx = 0;
    var dragging = false;
    var pointerId = null;

    function onPointerDown(e) {
      if (e.button !== undefined && e.button !== 0) return;
      if (e.target && e.target.closest && e.target.closest('.testimonials-lo__arrow, button, a, input, textarea, select')) return;
      dragging = true;
      dragStartX = e.clientX;
      dragDx = 0;
      pointerId = e.pointerId;
      row.classList.add('is-dragging');
      try { row.setPointerCapture(e.pointerId); } catch (err) {}
    }

    function onPointerMove(e) {
      if (!dragging) return;
      dragDx = e.clientX - dragStartX;
    }

    function onPointerUp() {
      if (!dragging) return;
      dragging = false;
      row.classList.remove('is-dragging');
      try { if (pointerId != null) row.releasePointerCapture(pointerId); } catch (err) {}
      pointerId = null;
      var threshold = 50;
      if (dragDx <= -threshold) go(1);
      else if (dragDx >= threshold) go(-1);
      else update();
    }

    row.addEventListener('pointerdown', onPointerDown);
    row.addEventListener('pointermove', onPointerMove);
    row.addEventListener('pointerup', onPointerUp);
    row.addEventListener('pointercancel', onPointerUp);
    row.addEventListener('pointerleave', onPointerUp);

    var resizeTimer = null;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        index = clampIndex(index, maxIndex(), loop);
        update();
      }, 100);
    }
    window.addEventListener('resize', onResize);

    update();

    container._tloCleanup = function () {
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      row.removeEventListener('keydown', onKey);
      row.removeEventListener('pointerdown', onPointerDown);
      row.removeEventListener('pointermove', onPointerMove);
      row.removeEventListener('pointerup', onPointerUp);
      row.removeEventListener('pointercancel', onPointerUp);
      row.removeEventListener('pointerleave', onPointerUp);
      window.removeEventListener('resize', onResize);
      clearTimeout(resizeTimer);
      if (waveObserver) waveObserver.disconnect();
    };
  }

  function destroy(container) {
    if (!container) return;
    if (typeof container._tloCleanup === 'function') container._tloCleanup();
    container.dataset.bound = '';
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(destroy);
  });
})();
